define('uikit/behaviors/tooltip.behavior',['require','exports','module','underscore','marionette','../definitions/modules/popup','../definitions/modules/transition'],function(require, exports, module) {
  //prettier-ignore
  var _  = require('underscore'),
      Mn = require('marionette');
  require('../definitions/modules/popup');
  require('../definitions/modules/transition');

  var TooltipBehavior = Mn.Behavior.extend({
    defaults: {
      popupClassName: 'ui popup',
      destroyOnHidden: true,
    },

    onFirstBeforeRender: function() {
      //prettier-ignore
      var self = this,
          useContentView = false,
          $popup = null,
          ignoreNextVisible = false;

      if (!this.getOption('html') && !_.isString(this.getOption('content')) && !this.getOption('title')) {
        useContentView = true;
        $popup = this.createPopupElement();
      }

      var popupOptions = _.omit(this.options, 'content', 'popupClassName');

      if (!useContentView) {
        popupOptions.content = this.getOption('content');
      }

      var contentView = null;
      this.view.$el.popup(
        _.extend({}, popupOptions, {
          popup: $popup,
          onShow: function() {
            if (useContentView && !contentView) {
              contentView = self.buildContentView();
              if (contentView) {
                self.injectView($popup, contentView);
              }
              $popup.transition('stop all');
              $popup.transition('clear queue');
              self.view.$el.popup('reposition');
              self.view.$el.popup('animate show');
              ignoreNextVisible = true;
              return;
            }
            var options = {};
            self.triggerMethod('popup:show', self, options);
            self.view.triggerMethod('popup:show', self.view, options);
          },
          onVisible: function() {
            if (ignoreNextVisible) {
              ignoreNextVisible = false;
              return;
            }
            var options = {};
            self.triggerMethod('popup:visible', self, options);
            self.view.triggerMethod('popup:visible', self.view, options);
          },
          onHide: function() {
            var options = {};
            self.triggerMethod('popup:hide', self, options);
            self.view.triggerMethod('popup:hide', self.view, options);
          },
          onHidden: function() {
            var options = {};
            self.triggerMethod('popup:hidden', self, options);
            self.view.triggerMethod('popup:hidden', self.view, options);
            if (contentView && self.getOption('destroyOnHidden')) {
              contentView.destroy();
              contentView = null;
              $popup.empty();
            }
          },
        })
      );

      this.on('before:destroy', function() {
        if (contentView) {
          contentView.destroy();
        }
        if ($popup) {
          $popup.remove();
        }
        this.$el.popup('destroy');
      });
    },

    createPopupElement: function() {
      var $popup = $('<div/>').addClass(this.getOption('popupClassName'));

      if (this.getOption('variation')) {
        $popup.addClass(this.getOption('variation'));
      }
      return $popup;
    },

    injectView: function($el, view) {
      $el.append(view.el);
      view.render();
      return view;
    },

    buildContentView: function() {
      var model = this.getOption('model') || this.view.model;
      return this.view.buildComponent(
        _.extend(
          {
            injectInternalViewsSynchronously: true,
          },
          Mn._getValue(this.getOption('content'), this, [model]),
          {
            model: model,
          }
        )
      );
    },
  });

  module.exports = TooltipBehavior;
});

